// Add data-attributes to add and remove positions to/from orderapproval

import api from './container';
import { KEYCODES } from './util/keycodes';
import { confirm, handleMessages, load } from './util';

$(document).on('submit.removeCartPositions', '[data-remove-orderapproval-positions]', function(event) {
  event.preventDefault();

  const $form = $(this).closest('form');
  const data = $form.serializeArray();

  $('[data-container-position-editmode]:checked').each((idx, input) => {
    data.push({ name: 'position_id', value: input.value });
  });

  load(
    this,
    $.stores.orderapproval.post($form.attr('action'), data),
  ).then((result) => {
    if (result.container.position_count === 0) {
      $(this).closest('.position-container').removeClass('position-container--editmode');
      $('[data-container-editmode]').addClass('hide');
    }
  });
});

$(document).on('submit.addCartPosition', '[data-add-orderapproval-position]', function(event) {
  event.preventDefault();
  api.addPosition($(this), 'orderapproval');
});

$(document).on('submit', '[data-add-orderapproval-group-position]', function(event) {
  event.preventDefault();
  api.updateQuantity(
    $(this).find('[data-add-orderapproval-group-position-quantity]').first(),
    'orderapproval',
    true,
  );
});

$(document).on('submit.orderapprovalGroupSelect', '[data-orderapproval-group-select]', function(event) {
  event.preventDefault();
  $.ajax({
    method: 'POST',
    url: $(this).attr('action'),
    data: $(this).serialize(),
  }).done((resp) => {
    const element = $(resp).appendTo($('body'));
    element.foundation().foundation('open');
  });
});

$(document).on('submit', '[data-create-and-add-to-orderapproval-group-form]', function(event) {
  event.preventDefault();
  const $form = $(this).closest('form');
  const $reveal = $form.closest('[data-reveal]');
  const formData = $form.serializeArray();

  if ($form.find('input[name="label"]').length === 0) {
    const label = $form.closest('[data-table-oninput]').find('[data-table-search-query]').text();
    formData.push({ name: 'label', value: label });
  }

  if ($('[data-bind-html="orderapproval:html"]').length) {
    formData.push({ name: 'render', value: 1 });
    formData.push({ name: 'calculate', value: 1 });
  }

  const promise = $.ajax({
    url: $form.attr('action'),
    method: 'POST',
    data: formData,
  }).then(handleMessages).then((data) => {
    setTimeout(() => $form.closest('[data-reveal]').foundation('close'), 1500);
    return data;
  });

  load($reveal, promise, {
    errorClass: 'error',
  });
});

$(document).on('submit.copyCartPositions', '[data-copy-orderapproval-positions]', function(event) {
  event.preventDefault();
  api.copyPositions($(this), 'orderapproval');
});

$(document).on('submit', '[data-add-orderapproval-position-diversitem]', function(event) {
  event.preventDefault();
  api.addPositionDiversItem($(this), 'orderapproval');
});

$(document).on('submit', '[data-update-orderapproval-position]', event => event.preventDefault());

$(document).on('keydown', '[data-update-orderapproval-position-quantity]', function(event) {
  if (event.which === KEYCODES.ENTER) {
    api.updateQuantity($(this), 'orderapproval');
  }
});

$(document).on('keyup', '[data-update-orderapproval-position-quantity]', function() {
  $(this).closest('form')[this.value !== this.defaultValue ? 'addClass' : 'removeClass']('ready');
});

$(document).on('blur', '[data-update-orderapproval-position-quantity]', function() {
  api.updateQuantity($(this), 'orderapproval');
});

$(document).on('submit', '[data-update-orderapproval-position-text]', event => event.preventDefault());
$(document).on('change', '[data-update-orderapproval-position-text]', function(event) {
  event.preventDefault();
  api.setPositionText($(this), 'orderapproval');
});

$(document).on('submit', '[data-remove-orderapproval-position]', function(event) {
  event.preventDefault();
  api.removePosition($(this), 'orderapproval');
});

$(document).on('submit', '[data-clear-orderapproval]', function(event) {
  event.preventDefault();
  api.clear($(this), 'orderapproval');
});

$(document).on('submit', '[data-orderapproval-import]', function(event) {
  event.preventDefault();
  api.importPositions($(this), 'orderapproval');
});

$(document).on('closeme.zf.reveal', '[data-orderapproval-import]', function() {
  $(this).removeClass('error');
  $(this).find('[data-orderapproval-import-messages]').html('').hide()
    .removeClass('alert');
});

$(document).on('click', '[data-change-orderapproval-position-reel]', function(event) {
  event.preventDefault();
  api.changePositionReel($(this), 'orderapproval');
});

$(document).on('submit', '[data-update-orderapproval-position-reel]', function(event) {
  event.preventDefault();
  api.updatePositionReel($(this), 'orderapproval');
});

$(document).on('change', '[data-orderapproval-positions-ordering]', function(event) {
  event.preventDefault();
  $(this).submit();
});

$(document).on('click', '[data-orderapproval-group-update]', function(event) {
  event.preventDefault();
  api.showUpdateReveal($(this));
});

$(document).on('submit', '[data-orderapproval-group-update-form]', function(event) {
  event.preventDefault();
  api.updateGroup($(this), 'orderapproval');
});

$(document).on('submit', '[data-orderapproval-group-delete]', function(event) {
  event.preventDefault();
  const $form = $(this);
  const confirmMsg = $form.attr('data-orderapproval-group-delete');
  $form.attr('data-confirm', confirmMsg);

  if (confirmMsg) {
    confirm($form).then(({ confirmed, reveal }) => {
      $form.removeAttr('data-confirm');
      if (confirmed) {
        load(
          reveal,
          $.stores.orderapproval.post($form.attr('action'), $form.serializeArray()),
        ).then(() => {
          reveal.foundation('close');
        });
      }
    }).catch(() => {
    });
  } else {
    load(
      $form,
      $.stores.orderapproval.post($form.attr('action'), $form.serializeArray()),
    );
  }
});
